import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { CONDITIONS } from '../../server/shared/constants';

const { FiFilter, FiActivity, FiBrain, FiAlertCircle } = FiIcons;

const AlertFilter = ({ activeFilter, onFilterChange }) => {
  const filters = [
    { id: 'all', label: 'All Alerts', icon: FiFilter },
    { id: CONDITIONS.CARDIAC, label: 'Cardiac', icon: FiActivity },
    { id: CONDITIONS.NEURO, label: 'Neuro/Mood', icon: FiBrain },
    { id: 'critical', label: 'Critical Only', icon: FiAlertCircle }
  ];



  return (
    <div className="grid grid-cols-2 gap-1.5 bg-gray-50 p-1.5 rounded-2xl border border-gray-100 w-full">
      {filters.map((f) => (
        <button
          key={f.id}
          onClick={() => onFilterChange?.(f.id)}
          className={`min-w-0 flex items-center justify-center gap-2 px-3 py-2 rounded-xl text-xs font-black transition-all ${
            activeFilter === f.id 
              ? 'bg-blue-600 text-white shadow-lg shadow-blue-100' 
              : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
          }`}
        >
          <SafeIcon icon={f.icon} className="flex-shrink-0" />
          <span className="uppercase tracking-widest truncate">{f.label}</span>
        </button>
      ))}
    </div>
  );
};

export default AlertFilter;
